import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $screen from 'wee-screen';

function moveShare() {
    const $share = $(':share');

    $screen.map([
        {
            max: 3,
            callback() {
                $share.insertAfter(':published');
            },
        }, {
            min: 4,
            callback() {
                $share.insertBefore(':related');
            },
        },
    ]);
}

export default new RouteHandler({
    init() {
        moveShare();
    }
})
